module.exports = __webpack_public_path__ + "static/img/14001007.c51368f9.png";